import { AlarmHistory } from 'src/types/Alarms';
import { get, QueryParams } from '../utils';

export interface AlarmHistorySearch {
  organisationId?: string;
  propertyId?: string;
  locationId?: string;
  alarmId?: string;
  /** ISO timestamp. The API requires it unless `limit` is set. */
  startTimestamp?: string;
  endTimestamp?: string;
  limit?: number;
  /**
   * Server-side metric filter (api.tetherme.io, additive). An API without it ignores the
   * parameter and returns every metric, so callers must still filter on `metric` themselves.
   */
  metric?: string;
}

/** `GET /microservice/alarmhistory`. Answers a bare array; filters that are not set are not sent. */
export async function searchAlarmHistory(search: AlarmHistorySearch): Promise<AlarmHistory[]> {
  const params: QueryParams = {};
  Object.entries(search).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params[key] = value as string | number;
    }
  });

  const response = await get<AlarmHistory[]>('alarmhistory', params);
  return response ?? [];
}
